import state from './state';
import getters from './getters';

export default {
  state,
  getters,
  namespaced: true,
};